import apiAsync from 'utils/api-async'

type SignedURLResponse = {
  signed_url: string
  file_key: string
  expires_in_min: number
}

export default async function fetchSignedDownloadURL(
  fileKey: string
): Promise<SignedURLResponse> {
  return apiAsync.requestSync({
    endpoint: 'signedDownloadURL',
    method: 'POST',
    obj: {
      filename: fileKey
    },
    showLoading: false
  })
}
